import FieldObject from './FieldObject.js'
import people from '../../people'

export default
class JsonField extends FieldObject {
  getStrategy () {
    return people.createStrategy(this.cxt.context, this.type)
  }
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  setCode (model, newCode, onChange) {
    let fstrategy = this.getStrategy()
    fstrategy.fetchData(newCode).then((data) => {
      this.setValue(
        model,
        newCode,
        fstrategy.createModelFromData(data),
        onChange
      )
      this.fillRef(model, data, onChange)
      this.cxt.updateItems(model)
    })
  }
  setValue (model, newCode, newObject, onChange) {
    if (!this.equalCode(model, newCode)) {
      onChange && onChange(model, this.name, newCode)
      model[this.name + '_CODE'] = newCode ? newCode + '' : null
    }
    model[this.name] = newCode ? JSON.stringify(newObject) : null
  }
  fillRef (model, data, onChange) {
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/JsonField.js